import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { View, StyleSheet, ActivityIndicator } from 'react-native';

import { range } from 'lodash';

import RadioForm, {
  RadioButton,
  RadioButtonInput,
  RadioButtonLabel,
} from 'react-native-simple-radio-button';

import Text from '../shared/Text';
import Image from '../shared/Image';
import Button from '../shared/Button';
import IconButton from '../shared/IconButton';

import heroStore from '../../stores/hero';
import { attack } from '../../stores/combat';
import appStore from '../../stores/app';

import { getBlockItems, getBodyPart } from '../../utils/combatUtils';

import { t } from '../../utils/appUtils';

import { BASE_COLOR, MARGIN_5, PADDING1, pOrT } from '../styleConstants';

export const ACTIONS_WIDTH = pOrT(215, 280);

const styles = StyleSheet.create({
  container: {
    height: pOrT(220, 250),
    width: ACTIONS_WIDTH,
    padding: PADDING1,
  },
  label: {
    fontSize: pOrT(11, 13),
    marginLeft: pOrT(-5, 0),
  },
  loading: {
    position: 'absolute',
    left: '50%',
    marginLeft: -80,
    top: 10,
  },
});

type Props = {
  opponentCombatWarriorId: string;
  onNextOpponent?: (() => void) | null;
};

type State = {
  attacks: (number | undefined)[];
  block: number | undefined;
};

@observer
export default class CombatActions extends Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      attacks: [...Array(heroStore.hero.feature.strikeCount)].map(() => undefined),
      block: undefined,
    };
  }

  onSelectAttack = (strikeNumber: number | 'all', item: number) => {
    this.setState((state: State) => {
      const { attacks } = state;
      if (strikeNumber === 'all') {
        attacks.forEach((iitem, index) => {
          attacks[index] = item;
        });
      } else {
        attacks[strikeNumber] = item;
      }

      return { attacks };
    });
  };

  onSelectBlock = (item: { value: number }) => {
    this.setState({
      block: item.value,
    });
  };

  onAttack = async () => {
    const { opponentCombatWarriorId } = this.props;
    const { attacks, block } = this.state;

    this.setState({
      attacks: [...Array(attacks.length)].map(() => undefined),
      block: undefined,
    });

    await attack(
      opponentCombatWarriorId,
      attacks as number[],
      // TODO: Flow need to find a way if logicaly this var cant be in this place null

      getBlockItems(block as number, heroStore.hero.feature.blockCount),
    );
  };

  render() {
    const { hero } = heroStore;
    const { block, attacks } = this.state;
    const { onNextOpponent } = this.props;

    const bodyPartsLength = 5;

    const attackItems = range(bodyPartsLength).map((item: number) => ({
      label: getBodyPart(item, t),
      value: item,
    }));
    const blockItems = range(bodyPartsLength).map((item: number, index: number) => {
      const label = range(hero.feature.blockCount)
        .map((iindex: number) => {
          let mergedIndex = index + iindex;
          // eslint-disable-next-line
          mergedIndex =
            mergedIndex >= bodyPartsLength ? mergedIndex - bodyPartsLength : mergedIndex;
          return getBodyPart(mergedIndex, t);
        })
        .join(' ');
      return { label, value: index };
    });

    return (
      <View>
        <Image
          style={{
            width: ACTIONS_WIDTH,
            height: pOrT(220, 250),
            position: 'absolute',
          }}
          source={require('../../assets/images/paper2.png')}
        />
        <View style={styles.container}>
          <View style={{ flexDirection: 'row', justifyContent: 'space-between' }}>
            <View>
              <Text bold>{t('combat.attack')}</Text>
              <RadioForm animation style={{ marginTop: MARGIN_5, alignItems: 'flex-start' }}>
                {attackItems.map((item: { label: string; value: number }) => (
                  <RadioButton labelHorizontal key={item.value}>
                    {range(hero.feature.strikeCount).map((number: number, index: number) => (
                      <View key={number} style={{ marginLeft: index > 0 ? 2 : 0 }}>
                        <RadioButtonInput
                          key={number}
                          buttonColor={BASE_COLOR}
                          obj={item}
                          buttonSize={pOrT(12, 18)}
                          index={item.value + number}
                          isSelected={attacks[number] === item.value}
                          onPress={() => this.onSelectAttack(number, item.value)}
                        />
                      </View>
                    ))}
                    <RadioButtonLabel
                      onPress={() => this.onSelectAttack('all', item.value)}
                      obj={item}
                      labelStyle={styles.label}
                      index={item.value}
                      labelHorizontal
                    />
                  </RadioButton>
                ))}
              </RadioForm>
            </View>

            <View>
              <Text bold>{t('combat.block')}</Text>
              <RadioForm style={{ marginTop: MARGIN_5, alignItems: 'flex-start' }}>
                {blockItems.map((item: { label: string; value: number }) => (
                  <RadioButton labelHorizontal key={item.value}>
                    <RadioButtonInput
                      key={item.value}
                      buttonSize={pOrT(12, 18)}
                      obj={item}
                      index={item.value}
                      isSelected={block === item.value}
                      buttonColor={BASE_COLOR}
                      onPress={() => this.onSelectBlock(item)}
                    />
                    <RadioButtonLabel
                      onPress={() => this.onSelectBlock(item)}
                      obj={item}
                      index={item.value}
                      labelHorizontal
                      labelStyle={styles.label}
                    />
                  </RadioButton>
                ))}
              </RadioForm>
            </View>
          </View>

          <View style={{ alignItems: 'center', marginTop: 5 }}>
            <Button
              disabled={
                appStore.smallLoading ||
                block === undefined ||
                attacks.some((item) => item === undefined)
              }
              onPress={this.onAttack}
            >
              {t('combat.go')}
            </Button>
            {onNextOpponent ? (
              <IconButton
                style={{
                  position: 'absolute',
                  right: 15,
                  top: 2,
                }}
                name="right"
                iconStyle={{
                  width: 32,
                  height: 32,
                }}
                source={require('../../assets/images/rightIcon.png')}
                size={16}
                onPress={onNextOpponent}
                title={t('combat.nextOpponent')}
              />
            ) : null}
            {appStore.smallLoading ? (
              <ActivityIndicator color={BASE_COLOR} style={styles.loading} />
            ) : null}
          </View>
        </View>
      </View>
    );
  }
}
